import mailingsRoutes from './mailings'
import contactsRoutes from './contacts'
import campaignsRoutes from './campaigns'

export default [...mailingsRoutes, ...contactsRoutes, ...campaignsRoutes]
